<template>
  <div class="card card4-card">
    <div class="background card4-bg">
      <div class="layout-tile card4-tile">
        <div class="layout-contents">
          <p class="layout-desc">想像我一样拥有干净的桌面吗</p>
          <p class="layout-desc">想像我一样打开东西时不用再缩小当前窗口吗</p>
          <p class="layout-desc">想像我一样不用每次打开文件夹时找半天吗</p>
          <p class="layout-desc card4-focus">点击下方按钮快来使用它吧!</p>
          <button class="download_btn card4-btn" @click="download">立马体验</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    download() {
      this.$downloadClient()
    }
  }
}
</script>

<style scoped>
.card4-card {
  overflow: visible;
}

.card4-bg {
  background-image: url('@/assets/desktop.jpg');
  background-color: #1a1a1a;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.card4-tile {
  position: absolute;
  top: 40%;
  left: 30%;
  transform: translate(-50%, -50%);
  background: linear-gradient(180deg, rgba(46, 117, 255, .9), rgba(104, 155, 255, .9));
}

.card4-focus {
  margin-top: 24px !important;
  font-size: 3.2rem !important;
  font-weight: 500;
}

.card4-btn {
  background: #FF8C42;
  color: #ffffff;
  border: 2px solid #D16A27;
  align-self: center;
}

.card4-btn:hover {
  background: #E07730;
}

@media (max-width: 1024px) {
  .card4-focus {
    font-size: 2rem !important;
  }
}

@media (max-width: 768px) {
  .card4-bg {
    background-position: center top;
  }

  .card4-tile {
    position: static;
    transform: none;
    margin: 24px 12px;
    max-width: calc(100% - 24px);
  }

  .card4-focus {
    font-size: 1.2rem !important;
    margin-top: 16px !important;
  }
}
</style>
